import React from 'react';
import templates from './templates';

export const NITZAV_SPOTLIGHT_WIDTH = 400;
export const NITZAV_SPOTLIGHT_HEIGHT = 300;

const DEFAULT_DATA = {
  name: 'תורם הקהילה',
  dedication: 'לעילוי נשמת',
  type: 'נציב היום',
  iconId: 'star'
};

export const NitzavSpotlightWidget = ({
  data = DEFAULT_DATA,
  onSave,
  template = 'Crown',
  title = 'נציב הקהילה',
  showTitle = false
}) => {
  const Template = templates[template];

  if (!Template) {
    return <div>Template not found: {template}</div>;
  }

  return (
    <Template
      data={data}
      onSave={onSave}
      title={title}
      showTitle={showTitle}
      NITZAV_SPOTLIGHT_WIDTH={NITZAV_SPOTLIGHT_WIDTH}
      NITZAV_SPOTLIGHT_HEIGHT={NITZAV_SPOTLIGHT_HEIGHT}
    />
  );
};